import React from "react";
import { useHasInsuranceVerification } from "hooks/featureFlags";
import { en } from "../i18n/en";

interface MonthlyCapBannerProps {
  used: number;
  limit: number;
  resetsAt: string;
  onUploadWithoutVerification?: () => void;
}

const formatResetsAt = (resetsAt: string): string => {
  const date = new Date(resetsAt);
  return date.toLocaleDateString("en-AU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export const MonthlyCapBanner: React.FC<MonthlyCapBannerProps> = ({
  used,
  limit,
  resetsAt,
  onUploadWithoutVerification,
}) => {
  const hasInsuranceVerification = useHasInsuranceVerification();

  if (!hasInsuranceVerification) {
    return null;
  }

  const formattedResetsAt = formatResetsAt(resetsAt);
  const message = en.cap.reached
    .replace("{used}", String(used))
    .replace("{limit}", String(limit))
    .replace("{resetsAt}", formattedResetsAt);

  return (
    <div
      className="rounded-md border border-amber-300 bg-amber-50 p-4"
      data-testid="monthly-cap-banner"
    >
      <p className="text-sm text-amber-800">{message}</p>
      {onUploadWithoutVerification && (
        <button
          type="button"
          className="mt-2 text-sm font-medium text-amber-700 underline hover:text-amber-900"
          onClick={onUploadWithoutVerification}
          data-testid="upload-without-verification-btn"
        >
          {en.cap.uploadWithout}
        </button>
      )}
    </div>
  );
};
